/* Shops & Garages — stand-in for the planner's Cloudflare /api/* endpoints.
   Shopify cannot run those server functions, and a WC3 (GHL) API key must never ship in
   page code (anyone can read it from the page source). So leads go to a WC3 INBOUND
   WEBHOOK instead: a trigger URL, set in the theme editor on the Shops & Garages section.
   Contact, opportunity and pipeline are created by the WC3 workflow behind that webhook.

   - /api/list         : lead → webhook. A quote request then goes to the thank-you page.
                         No webhook set → Zak's demo mode (nothing filed; the page says so).
   - /api/financing    : off — Handley has not confirmed Flexiti on its own site
   - /api/lot          : unavailable — the "see it on your lot" card stays hidden
   - /api/packet-email : not sent — the page falls back to a mailto link */
(function () {
  var realFetch = window.fetch.bind(window);
  function reply(body) {
    return Promise.resolve(new Response(JSON.stringify(body), { status: 200, headers: { 'Content-Type': 'application/json' } }));
  }
  function ref(seed) {
    var h = 0, s = String(seed || Date.now());
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return 'HL-' + h.toString(36).toUpperCase().slice(0, 6);
  }
  function config() {
    var app = document.querySelector('.sg-app');
    return {
      webhook: (app && app.dataset.leadWebhook || '').trim(),
      thankYou: (app && app.dataset.thankYou || '').trim()
    };
  }
  // Post the lead. A webhook that does not send CORS headers still receives a no-cors POST;
  // the response is then unreadable, so a network-level success counts as delivered.
  function deliver(url, payload) {
    var body = JSON.stringify(payload);
    return realFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { if (!r.ok) throw new Error('webhook ' + r.status); return true; })
      .catch(function (e) {
        if (e && /webhook \d+/.test(e.message)) throw e;
        return realFetch(url, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: body }).then(function () { return true; });
      });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var path = url.replace(location.origin, '');
    if (path.indexOf('/api/') !== 0) return realFetch(input, init);
    if (path.indexOf('/api/financing') === 0) return reply({ state: 'off', rangeLive: false });
    if (path.indexOf('/api/lot') === 0) return reply({ ok: false });
    if (path.indexOf('/api/packet-email') === 0) return reply({ ok: false });
    if (path.indexOf('/api/list') !== 0) return reply({ ok: false });

    var body = {};
    try { body = JSON.parse((init && init.body) || '{}'); } catch (e) {}
    var lead = body.lead || body;
    var reference = ref((lead.email || '') + (body.plan || ''));
    var base = { ok: true, saved: false, emailed: false, packet: null, reference: reference, lead: { name: lead.name || '' } };
    var cfg = config();

    // honeypot: the hidden "company" field is filled only by bots
    if (String(body.company || '').trim()) return reply(Object.assign({}, base, { stored: true }));
    if (!cfg.webhook) return reply(Object.assign({}, base, { stored: false }));

    // Flat, plainly named fields first, so the WC3 workflow maps one-to-one; the full
    // planner body (brief, options) rides along for anyone who wants more.
    // WC3 prints any nested object as "[object Object]" (Shirley, 9 Oct), so every builder
    // answer is ALSO given as plain text, and the whole build as one readable `build_summary`.
    var brief = body.brief || {};
    var plan = brief.standardPlan || {};
    var spec = brief.spec || {};
    var fin = spec.finishes || {};
    var extras = body.extras || {};
    var qual = body.qual || {};
    var fullName = String(body.name || lead.name || '').trim();
    var t = function (v) { return v == null ? '' : String(v).trim(); };
    // the engine sends trim/door as hex only; name them from the page's own swatch buttons
    var colourName = function (hex) {
      if (!hex) return '';
      var b = document.querySelector('.sg-app [data-hex="' + String(hex).toUpperCase() + '"], .sg-app [data-hex="' + String(hex).toLowerCase() + '"]');
      var n = b && (b.getAttribute('aria-label') || b.getAttribute('title') || b.textContent);
      return n ? String(n).trim().replace(/\s*(trim|door)$/i, '') : String(hex);
    };
    var items = (brief.items || []).map(function (i) { return i && (i.text || i.id); }).filter(Boolean);
    var building = plan.name ? plan.name + (plan.label ? ' (' + plan.label + ')' : '')
      : (brief.buildingTypeText || 'Custom building') + (spec.width && spec.depth ? ' (' + spec.width + "' × " + spec.depth + "')" : '');
    var answers = {
      building: building,
      building_type: t(brief.buildingTypeText),
      plan_status: t(brief.statusText),
      siding_colour: t(fin.sidingLabel || body.sidingLabel) + (fin.sidingType ? ' (' + fin.sidingType + ')' : ''),
      roof_colour: t(fin.roofingLabel || body.roofLabel) + (fin.roofingType ? ' (' + fin.roofingType + ')' : ''),
      trim_colour: colourName(fin.trimColor || body.trim),
      door_colour: colourName(fin.doorColor || body.door),
      quote_items: items.join(', '),
      town: t(extras.town || body.town),
      timeline: t(extras.timeline || qual.timeline || body.timeline),
      site: t(extras.site || qual.site),
      builder: t(extras.builder || qual.builder),
      foundation: t(extras.foundation || qual.foundation),
      foundation_help: extras.foundationHelp ? 'Yes' : '',
      drawings: t(extras.drawings || qual.drawings),
      plan_sheet: plan.pdf ? 'https:' + String(plan.pdf).replace(/^https?:/, '') : ''
    };
    var label = {
      building: 'Building', building_type: 'Type', plan_status: 'Plan', siding_colour: 'Siding', roof_colour: 'Roof',
      trim_colour: 'Trim', door_colour: 'Door colour', quote_items: 'Quote items', town: 'Town', timeline: 'Timeline',
      site: 'Site', builder: 'Builder', foundation: 'Foundation', foundation_help: 'Wants foundation help',
      drawings: 'Drawings', plan_sheet: 'Plan sheet'
    };
    var summary = ['Shops & Garages planner – materials quote request'];
    Object.keys(label).forEach(function (k) { if (answers[k]) summary.push(label[k] + ': ' + answers[k]); });
    if (t(body.notes || extras.notes)) summary.push('Customer notes: ' + t(body.notes || extras.notes));
    summary.push('Reference: ' + reference);
    var payload = Object.assign({}, body, answers, {
      build_summary: summary.join('\n'),
      first_name: fullName.split(/\s+/)[0] || '',
      last_name: fullName.split(/\s+/).slice(1).join(' '),
      full_name: fullName,
      // Estimator-compatible aliases. The WC3 workflow behind this webhook
      // ("HandleyEstimatorQuoteSubmissionExternal") maps the contact from the Handley
      // estimator's SNAKE_CASE webhook keys — customer_name / customer_email /
      // customer_phone, location (-> City), subtotal (-> Contact source) — verified from the
      // trigger's 2026-02-08 mapping sample (GHL DISPLAYS them prettified as "Customer Name"
      // etc., which is misleading). Emit those exact keys so the existing mapping fills
      // name/email/phone instead of erroring "no value found for any mapped field". If that
      // workflow is ever remapped to plain keys (full_name/phone/email/town), drop these.
      customer_name: fullName,
      customer_email: (lead.email || '').trim(),
      customer_phone: body.phone || '',
      location: (extras.town || body.town || '').trim(),
      subtotal: 'Shops & Garages planner',
      email: (lead.email || '').trim(),
      phone: body.phone || '',
      town: extras.town || '',
      plan_name: plan.name || (body.brief && body.brief.buildingTypeText) || 'Custom building',
      plan_size: plan.label || body.plan || '',
      siding: body.profile || '',
      roof: body.roofKind || '',
      customer_notes: body.notes || extras.notes || '',
      opportunity_name: 'S&G – ' + fullName + ' – ' + (plan.name || 'Custom building'),
      lead_source: 'Shops & Garages planner',
      reference: reference,
      kind: body.source === 'capture' ? 'saved-build' : 'quote-request',
      store: 'Handley Lumber',
      page: location.href.split('#')[0],
      submittedAt: new Date().toISOString()
    });
    return deliver(cfg.webhook, payload).then(function () {
      if (body.source !== 'capture' && cfg.thankYou) {
        var to = cfg.thankYou + (cfg.thankYou.indexOf('?') < 0 ? '?' : '&') + 'ref=' + encodeURIComponent(reference);
        setTimeout(function () { location.assign(to); }, 50);
      }
      return new Response(JSON.stringify(Object.assign({}, base, { stored: true })), { status: 200, headers: { 'Content-Type': 'application/json' } });
    });
    // a failed delivery rejects, and the planner shows its own "Could not send just now… try again"
  };
})();
